import axios from "axios";
import { ADMIN_BASE_URL, BACKEND_BASE_URL, DASHBOARD_BASE_URL, printDebugLog, SUCCESS } from "../../constants/Constants";

export const fetchConfig = async ({
    authUser, activeShopHash, configName,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        const catgUrl = `${BACKEND_BASE_URL}get-single-config?apiToken=${authUser.apiToken}&shopHash=${activeShopHash.id}&configName=${configName}`;
        const response = await axios.get(catgUrl);
        printDebugLog("fetchConfig", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(configName, response.data.payLoad.val);
        } else {
            onResponseCallback(configName, null);
        }
    } catch (error) {
        console.error(`fetchConfig : ${configName}`, error);
        onResponseCallback(configName, null);
    }
};

export const fetchSpecialConfig = async ({
    authUser, activeShopHash, configName,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        const catgUrl = `${ADMIN_BASE_URL}get-special-config?apiToken=${authUser.apiToken}&shopHash=${activeShopHash.id}&configName=${configName}`;
        const response = await axios.get(catgUrl);
        printDebugLog("fetchConfig", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(configName, response.data.payLoad);
        } else {
            onResponseCallback(configName, null);
        }
    } catch (error) {
        console.error(`fetchConfig : ${configName}`, error);
        onResponseCallback(configName, null);
    }
};

export const fetchHotelEmployee = async ({
    authUser, activeShopHash, setLoader, onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        setLoader(true);
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
            }
        }
        const response = await axios.post(`${DASHBOARD_BASE_URL}fetch-hotel-employee`, data);
        if (response.data.status === SUCCESS) {
            const payload = response?.data?.payLoad;
            onResponseCallback(payload);
        } else {
            onResponseCallback(null);
        }
    } catch (err) {
        console.error("fetchHotelEmployee", err);
        onResponseCallback(null);
    } finally {
        setLoader(false);
    }
};